<template>
    <div id="app">
        <NavigationMenu :class="{'hidden': this.$route.name == 'home'}"/>
        <div class="viewWindow" ref="viewWindow" :class="{'home': this.$route.name == 'home'}">
            <TransitionPage>
                <router-view/>
            </TransitionPage>
        </div>
    </div>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu'
import ScenarioNavigationMenu from '@/components/ScenarioNavigationMenu'
import TransitionPage from '@/transitions/TransitionPage'

export default {
    components: {
        NavigationMenu,
        ScenarioNavigationMenu,
        TransitionPage
    },
    methods: {
        handleResize() {
            var {offsetWidth, offsetHeight} = this.$refs.viewWindow
            if (offsetWidth/offsetHeight > this.$root.aspectRatio) { // wider
                this.$root.viewWindow.width = offsetWidth + 'px'
                this.$root.viewWindow.height = offsetWidth / this.$root.aspectRatio + 'px'
            } else { // taller
                this.$root.viewWindow.width = offsetHeight * this.$root.aspectRatio + 'px'
                this.$root.viewWindow.height = offsetHeight + 'px'
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.$root.$on('size-check', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>


<style lang="scss">
@import 'assets/scss/import.scss';



html, body {
    height: 100%;
    width: 100%;
}

#app {
    font-family: 'Aktiv Grotesk Normal', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    overflow: hidden;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: $colour__primary1;
}


.viewWindow {
    height: calc(100% - #{$menuHeight});
    &.home {
        height: 100%;
    }
    transition: height 0.3s ease;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    & > div {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
}

.viewWindow, #home {
    background-color: $white;
}

.menuBar {
    transition: transform 0.3s ease;
    transform: translateY(0);
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    &.hidden {
        transition-delay: 0s;
        transform: translateY(-#{$menuHeight});
    }
}

.fade- {
    &enter-active, &leave-active {
        transition: opacity 0.3s ease-in-out;
    }
    &enter, &leave-to {
        opacity: 0;  
    }
}

.drug_enforcement_hotspots {
    [data-hotspot-key^="1"] {
        top: 51%;
        left: 36%;
    }
    [data-hotspot-key^="2"] {
        top: 73%;
        left: 50%;
    }
    [data-hotspot-key^="3"] {
        top: 66%;
        left: 24%;
    }
    [data-hotspot-key^="4"] {
        top: 78%;
        left: 30%;
    }
}

.expeditionary_hotspots {
    [data-hotspot-key^="1"] {
        top: 67%;
        left: 52%;
    }
    [data-hotspot-key^="2"] {
        top: 80%;
        left: 60%;
    }
    [data-hotspot-key^="3"] {
        top: 38%;
        left: 67%;
    }
    [data-hotspot-key^="4"] {
        top: 58%;
        left: 70%;
    }
    [data-hotspot-key^="5"] {
        top: 71%;
        left: 67%;
    }
    [data-hotspot-key^="6"] {
        top: 52%;
        left: 57%;
    }
}

.military_base_hotspots {
    [data-hotspot-key^="1"] {
        top: 60%;
        left: 58%;
    }
    [data-hotspot-key^="2"] {
        top: 44%;
        left: 56%;
    }
    [data-hotspot-key^="3"] {
        top: 36%;
        left: 36%;
    }
    [data-hotspot-key^="4"] {
        top: 19%;
        left: 70%;
    }
    [data-hotspot-key^="5"] {
        top: 67%;
        left: 67%;
    }
    [data-hotspot-key^="6"] {
        top: 52%;
        left: 37%;
    }
    [data-hotspot-key^="7"] {
        top: 43%;
        left: 70%;
    }
}

.disaster_relief_hotspots {
    [data-hotspot-key^="1"] {
        top: 44%;
        left: 36%;
    }
    [data-hotspot-key^="2"] {
        top: 50%;
        left: 60%;
    }
    [data-hotspot-key^="3"] {
        top: 22%;
        left: 61%;
    }
    [data-hotspot-key^="4"] {
        top: 58%;
        left: 70%;
    }
    [data-hotspot-key^="5"] {
        top: 37%;
        left: 69%;
    }
}

.airbase_hotspots {
    [data-hotspot-key^="1"] {
        top: 34%;
        left: 43%;
    }
    [data-hotspot-key^="2"] {
        top: 27%;
        left: 60%;
    }
    [data-hotspot-key^="3"] {
        top: 55%;
        left: 43%;
    }
    [data-hotspot-key^="4"] {
        top: 55%;
        left: 61%;
    }
    [data-hotspot-key^="5"] {
        top: 75%;
        left: 65%;
    }
    [data-hotspot-key^="6"] {
        top: 50%;
        left: 25%;
    }
}

</style>
